import React from "react";
import PropTypes from "prop-types";

export const SPINNER_CLASSNAME = "spinner-web-sdk";

const Spinner = ({ className = "" }) => (
  <div className={`${SPINNER_CLASSNAME} ${className}`} />
);

Spinner.propTypes = {
  className: PropTypes.string
};

export default Spinner;
